/** Placeholder until portal statement API is wired. */
export const PortalStatementsPage = () => (
  <div className="p-4">
    <h1>Account statement</h1>
    <p>Your running balance and statement history will appear here.</p>
  </div>
);
